module.exports = __webpack_public_path__ + "img/newsletter-dark.a1cc8819.svg";